<template>
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.01001 10.005H5.01001C3.90501 10.005 3.01001 9.11 3.01001 8.005V5.005C3.01001 3.9 3.90501 3.005 5.01001 3.005H8.01001C9.11501 3.005 10.01 3.9 10.01 5.005V8.005C10.01 9.11 9.11501 10.005 8.01001 10.005Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.01 10.005H16.01C14.905 10.005 14.01 9.11 14.01 8.005V5.005C14.01 3.9 14.905 3.005 16.01 3.005H19.01C20.115 3.005 21.01 3.9 21.01 5.005V8.005C21.01 9.11 20.115 10.005 19.01 10.005Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.01001 21.005H5.01001C3.90501 21.005 3.01001 20.11 3.01001 19.005V16.005C3.01001 14.9 3.90501 14.005 5.01001 14.005H8.01001C9.11501 14.005 10.01 14.9 10.01 16.005V19.005C10.01 20.11 9.11501 21.005 8.01001 21.005Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.51 15.005V20.005"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.01 17.505H15.01"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
